
import Login from "@/services/api_config/LoginApi";
import Rest from "@/services/api_config/RestApi";

export default {
  login(credentials) {
    return Login().post("auth/ticketko-login", credentials);
  },
  getPages(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    return Rest().get("ticketko/page?" + data.substring(1));
  },
  getCompanyPages(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    return Rest().get("ticketko/com/page?" + data.substring(1));
  },
  getSubCompanyPages(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    return Rest().get("ticketko/sub/page?" + data.substring(1));
  },
  getPage(id) {
    return Rest().get("ticketko/page/" + id);
  },
  addPage(data) {
    return Rest().put("ticketko/add-page", data);
  },
  editPage(id, data) {
    return Rest().patch("ticketko/page/" + id, data);
  },
  deletePage(id) {
    return Rest().delete("ticketko/page/" + id);
  },
  getModules(params) {
    var data = ``;
    if (
      params.page_id !== null &&
      params.page_id !== undefined &&
      params.page_id !== ""
    ) {
      data += `&page_id=${params.page_id}`;
    }
    return Rest().get("ticketko/module?" + data.substring(1));
  },
  getCompanyModules(params) {
    var data = ``;
    if (
      params.page_id !== null &&
      params.page_id !== undefined &&
      params.page_id !== ""
    ) {
      data += `&page_id=${params.page_id}`;
    }
    return Rest().get("ticketko/com/module?" + data.substring(1));
  },
  getSubCompanyModules(params) {
    var data = ``;
    if (
      params.page_id !== null &&
      params.page_id !== undefined &&
      params.page_id !== ""
    ) {
      data += `&page_id=${params.page_id}`;
    }
    return Rest().get("ticketko/sub/module?" + data.substring(1));
  },
  getModule(id) {
    return Rest().get("ticketko/module/" + id);
  },
  editModule(id, data) {
    return Rest().patch("ticketko/module/" + id, data);
  },
  addModule(data) {
    return Rest().put("ticketko/add-module", data);
  },
  deleteModule(id) {
    return Rest().delete("ticketko/module/" + id);
  },
  getRoles(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    return Rest().get("ticketko/role?" + data.substring(1));
  },
  getRole(id) {
    return Rest().get("ticketko/role/" + id);
  },
  editRole(id, data) {
    return Rest().patch("ticketko/role/" + id, data);
  },
  deleteRole(id) {
    return Rest().delete("ticketko/role/" + id);
  },
  addRole(data) {
    return Rest().put("ticketko/add-role", data);
  },
  getCompanyRoles(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    return Rest().get("ticketko/com/role?" + data.substring(1));
  },
  getCompanyRole(id) {
    return Rest().get("ticketko/com/role/" + id);
  },
  editCompanyRole(id, data) {
    return Rest().patch("ticketko/com/role/" + id, data);
  },
  deleteCompanyRole(id) {
    return Rest().delete("ticketko/com/role/" + id);
  },
  addCompanyRole(data) {
    return Rest().put("ticketko/com/add-role", data);
  },
  getSubCompanyRoles(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("ticketko/sub/role?" + data.substring(1));
  },
  getSubCompanyRole(id) {
    return Rest().get("ticketko/sub/role/" + id);
  },
  editSubCompanyRole(id, data) {
    return Rest().patch("ticketko/sub/role/" + id, data);
  },
  deleteSubCompanyRole(id) {
    return Rest().delete("ticketko/sub/role/" + id);
  },
  addSubCompanyRole(data) {
    return Rest().put("ticketko/sub/add-role", data);
  },
  getEmployees(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("ticketko/employee?" + data.substring(1));
  },
  getEmployee(id) {
    return Rest().get("ticketko/employee/" + id);
  },
  editEmployee(id, data) {
    return Rest().patch("ticketko/employee/" + id, data);
  },
  editTicketkoEmployee(id, data) {
    return Rest().patch("jti/employee/" + id, data);
  },
  getUnassignedEmployees(params) {
    let data = ``;
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("ticketko/unassigned-employee?" + data.substring(1));
  },
  deleteEmployee(id) {
    return Rest().delete("ticketko/employee/" + id);
  },
  assignEmployees(params) {
    return Rest().post("ticketko/assign-employee/", params);
  },
  getUser(id) {
    return Rest().get("jti/user/" + id);
  },
  editUser(id, data) {
    return Rest().patch("jti/user/" + id, data);
  },
  getAccessCard(id) {
    return Rest().get("jti/access-card/" + id);
  },
  getCompanies(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    return Rest().get("ticketko/company?" + data.substring(1));
  },
  getCompany(id) {
    return Rest().get("ticketko/company/" + id);
  },
  getDevices(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    return Rest().get("ticketko/device?" + data.substring(1));
  },
  getDevice(id) {
    return Rest().get("ticketko/device/" + id);
  },
  deleteDevice(id) {
    return Rest().delete("ticketko/device/" + id);
  },
  getUnassignedDevices(params) {
    let data = ``;
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("ticketko/unassigned-device?" + data.substring(1));
  },
  assignDevices(data) {
    return Rest().post("ticketko/assign-device/", data);
  },
  getSettlements(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.status !== null &&
      params.status !== undefined &&
      params.status !== ""
    ) {
      data += `&status=${params.status}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    return Rest().get("ticketko/settlement?" + data.substring(1));
  },
  getSettlement(id) {
    return Rest().get("ticketko/settlement/" + id);
  },
  settleSettlement(id, data) {
    return Rest().patch("ticketko/settle-settlement/" + id, data);
  },
  getSubCompanies(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    return Rest().get("ticketko/sub-company?" + data.substring(1));
  },
   getEsales(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }    
    return Rest().get(
      "ticketko/esales?" + data.substring(1)
    );
  },
  getRemittanceWireless(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    return Rest().get(
      "ticketko/remmitance-wireless?" + data.substring(1)
    );
  },
  getRemittanceSync(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    return Rest().get(
      "ticketko/remmitance-sync?" + data.substring(1)
    );
  },
  getDispatchWireless(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    return Rest().get(
      "ticketko/dispatch-wireless?" + data.substring(1)
    );
  },
  getDispatchSync(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    return Rest().get("ticketko/dispatch-sync?" + data.substring(1));
  },
  getArrivalWireless(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    return Rest().get(
      "ticketko/arrival-wireless?" + data.substring(1)
    );
  },
  getArrivalSync(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    return Rest().get("ticketko/arrival-sync?" + data.substring(1));
  },
  getTicketWireless(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.payment_type !== null &&
      params.payment_type !== undefined &&
      params.payment_type !== ""
    ) {
      data += `&payment_type=${params.payment_type}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    return Rest().get(
      "ticketko/ticket-wireless?" + data.substring(1)
    );
  },
  getTicketSync(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.payment_type !== null &&
      params.payment_type !== undefined &&
      params.payment_type !== ""
    ) {
      data += `&payment_type=${params.payment_type}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    return Rest().get("ticketko/ticket-sync?" + data.substring(1));
  },
  getInspectionSync(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    return Rest().get(
      "ticketko/inspection-sync?" + data.substring(1)
    );
  },
  getInspectionWireless(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    return Rest().get(
      "ticketko/inspection-wireless?" + data.substring(1)
    );
  },
  getTicketExceptionReport(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.payment_type !== null &&
      params.payment_type !== undefined &&
      params.payment_type !== ""
    ) {
      data += `&payment_type=${params.payment_type}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    if (
      params.aligned !== null &&
      params.aligned !== undefined &&
      params.aligned !== ""
    ) {
      data += `&aligned=${params.aligned}`;
    }
    return Rest().get(
      "ticketko/report/ticket-exception?" + data.substring(1)
    );
  },
  alignTicket(id) {
    return Rest().post("ticketko/report/ticket-exception/align/" + id);
  },
  getDispatchExceptionReport(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.payment_type !== null &&
      params.payment_type !== undefined &&
      params.payment_type !== ""
    ) {
      data += `&payment_type=${params.payment_type}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    if (
      params.aligned !== null &&
      params.aligned !== undefined &&
      params.aligned !== ""
    ) {
      data += `&aligned=${params.aligned}`;
    }
    return Rest().get(
      "ticketko/report/dispatch-exception?" + data.substring(1)
    );
  },
  alignDispatch(id) {
    return Rest().post("ticketko/report/dispatch-exception/align/" + id);
  },
  getTicketDateExceptionReport(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    return Rest().get(
      "ticketko/report/ticket-date-exception?" + data.substring(1)
    );
  },
  getTripManifests(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    return Rest().get(
      "ticketko/report/trip-manifest?" + data.substring(1)
    );
  },
  getTripManifest(id) {
    return Rest().get("ticketko/report/trip-manifest/" + id);
  },
  getTripManifestTickets(id) {
    return Rest().get("ticketko/report/trip-manifest-dispatch/" + id);
  },
};
